import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = {
  key: 0,
  class: "contents-list-icon-main"
}
const _hoisted_4 = { class: "contents-question-confirm-text" }
const _hoisted_5 = { class: "contents-question-button" }
const _hoisted_6 = ["disabled"]

import { processing, processend } from "@/utils/view";
import { ref, onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import QuestionTableConfirm from "@/components/modules/healthCare/QuestionTableConfirm.vue";
import { UserAnswer } from "@/models/healthCare/userAnswer";
import { Question } from "@/models/healthCare/types/question";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import { _$t } from "@/utils/i18n";
import Footer from "@/components/modules/base/Footer.vue";

// ---- Constant ----------------------------------------------
const componentId = "generalpurpose03-02-b";

export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyFormConfirm',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const questionData = ref<Question[]>([]);
const isSubmitting = ref(false);
// ---- Variable ----------------------------------------------
let surveyCode = "";
// セッションエラーチェック
let sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ---- Methods ----------------------------------------------
//キャンセル処理
const cancel = () => {
  router.push({
    name: "health-care/survey/form",
    params: { surveyCode: surveyCode },
  });
};

//回答送信
const submit = async () => {
  const userAnswer = new UserAnswer();
  // insert question
  const [_model, _response, error] = await userAnswer.insertData(
    questionData.value
  );
  if (error) {
    let decodedMessage = decodeURIComponent(
      error.error?.response?.data?.message
    );
    const status = error.error?.response?.status;
    // セッションエラー
    if (status === 408) {
      sessionErr.value = true;
    } else if (status === 403) {
      decodedMessage = _$t("msg_common_uncaughtException");
      sessionErr.value = true;
    }
    errorDialog.open(decodedMessage);
    return;
  }
  // clear store
  isSubmitting.value = true;
  await store.dispatch("clearQuestions", { sessionId: surveyCode });
  await router.push("/health-care/survey/complete");
};

// ---- Vue lifeCycle ----------------------------------------------
onMounted(async () => {
  surveyCode = route.params.surveyCode as string;
  if (surveyCode) {
    questionData.value = store.getters.getQuestions({ sessionId: surveyCode });
  }

  //reload page
  if (!questionData.value || questionData.value.length === 0) {
    router.push({
      name: "health-care/survey/form",
      params: { surveyCode: surveyCode },
    });
  }
  document.title = questionData.value[0].survey_title;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("header", null, [
          _createElementVNode("h1", { class: "header-icon" }, [
            _createElementVNode("a", { href: "#" }, [
              _createElementVNode("img", { src: "/server/necs/images/kanshin_logo.png" })
            ])
          ])
        ], -1)),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            (questionData.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(questionData.value[0].survey_title), 1))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t("survey_msg_please_button_submit")), 1),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("survey_msg_please_button_cancel")), 1)
          ]),
          _createVNode(QuestionTableConfirm, {
            questions: questionData.value,
            "onUpdate:questions": _cache[0] || (_cache[0] = ($event: any) => ((questionData).value = $event))
          }, null, 8, ["questions"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "cancel-button",
              onClick: cancel
            }, _toDisplayString(_ctx.$t("survey_button_cancel")), 1),
            _createElementVNode("button", {
              class: "submit-button",
              onClick: submit,
              disabled: isSubmitting.value
            }, _toDisplayString(_ctx.$t("survey_button_submit")), 9, _hoisted_6)
          ])
        ])
      ])
    ]),
    _createVNode(Footer, { "scroll-target": componentId }),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})